import React from 'react';
import ServiceContactInfoGroupV2 from '../Components/ServiceContactInfoGroupV2';
import {useIntl} from 'react-intl';
import {Container} from 'react-bootstrap';
import {PageTitle} from '../../../_metronic/layout/core';
import {Link} from 'react-router-dom';
import InfoBanner  from "../Components/InfoBanner";

const Contact = () => {
  const intl = useIntl(); 

  return (
    <Container fluid className='px-0'>
      <PageTitle breadcrumbs={[]}>{intl.formatMessage({id: 'CONTACT.TITLE'})}</PageTitle>
        <div style={{marginLeft: '24px'}}>
            <InfoBanner>
                {
                    intl.formatMessage({id:'INFO.BANNER'},
                        {Link:(<Link to={'/support'}>{intl.formatMessage({id:'INFO.BANNER.LINK'})}</Link>),}
                    )
                }
            </InfoBanner>
        </div>

      <div style={{display:'flex', margin: '0 auto', marginTop: '0px'}}>
        <div style={{flex:1,"backgroundColor": "#fff","zIndex": "9","marginLeft": "24px","borderRadius": "15px"}}>
          <ServiceContactInfoGroupV2 ></ServiceContactInfoGroupV2>
        </div>
      </div>
      <br/><br/><br/><br/><br/>
      
    </Container>
  );
};

export default Contact;
